import React, {useState, useRef} from 'react'
import {observer} from 'mobx-react-lite'
import {useProductDetail} from '../../store/hooks/useProductDetail'
import {Container, Stack} from '../../vanilla'
import {ProductBuyModule} from './product-buy-module'
import {ProductInfoModule} from './product-info'
import {PDPAwardSlot, ProductInformation} from '../../types/cms'
import {useCustomerStore} from '../../store/hooks/useStore'

interface ProductDetailProps {
  productId: string
  productInformation: ProductInformation
  pdpAwardSlot: PDPAwardSlot | null
  isBundle: boolean | undefined
}

export const ProductDetail = observer(
  ({productId, productInformation, pdpAwardSlot, isBundle}: ProductDetailProps) => {
    const productDetail = useProductDetail(productId)
    const {currentCustomerGroups} = useCustomerStore()

    const [activeTab, setActiveTab] = useState(0) 
    const reviewsTabRef = useRef<HTMLDivElement>(null)

    const openReviewTabAndScroll = () => {
      setActiveTab(1) 
      if (reviewsTabRef.current) {
        reviewsTabRef.current.scrollIntoView({ behavior: 'smooth' }) 
      }
    }

    if (!productDetail?.product) {
      return null
    }

    return (
      <Container paddingX={['4px', '8px', '16px']}>
        <Stack spacing="20px">
          <ProductBuyModule
            customerGroups={currentCustomerGroups}
            productDetail={productDetail}
            openReviewTabAndScroll={openReviewTabAndScroll} 
          />
          <ProductInfoModule
            productDetail={productDetail}
            productInformation={productInformation}
            pdpAwardSlot={pdpAwardSlot}
            selectedIndex={activeTab} 
            onTabChange={setActiveTab}
            reviewsTabRef={reviewsTabRef}
            isBundle={isBundle}
          />
        </Stack>
      </Container>
    )
  },
)